import React from "react";
import { motion } from "framer-motion";
import Img1 from "../../media/restaurant-image1.png";
// import Img2 from "../../media/club-tenis-img2.jpg";
// import Img3 from "../../media/club-tenis-img4.jpg";
import ImgLogo from "../../media/restaurant-logo.png";
import ImgBg from "../../media/restaurant-bg.jpg";

const CardRestaurant = () => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -20, opacity: 0 }}
      transition={{ duration: 0.6 }}
      key="card-club"
      className="services-content-images-image-card"
    >
      <img
        className="services-content-images-image-card-bg"
        src={ImgBg}
        alt=""
      />
      <motion.img
        initial={{ y: 10, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="services-content-images-image-card-logo"
        src={ImgLogo}
        alt=""
      />
      <motion.img
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -20, opacity: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
        className="services-content-images-image-card-image1"
        style={{ outline: "none", top: "auto", bottom: "-8rem", left: "-3rem" }}
        src={Img1}
        alt=""
      />
    </motion.div>
  );
};

export default CardRestaurant;
